import { ButtonHTMLAttributes, PropsWithChildren } from 'react';

type Styling =
  | 'white'
  | 'primary'
  | 'outline'
  | 'dark'
  | 'naked'
  | 'naked-blue'
  | 'gray'
  | 'naked-green';

interface Props {
  className?: string;
  styling?: Styling;
  size?: 'sm' | 'lg';
}

export default function Button({
  className = '',
  styling = 'primary',
  children,
  size,
  ...rest
}: PropsWithChildren<ButtonHTMLAttributes<HTMLButtonElement> & Props>) {
  const getClasses = () => {
    switch (styling as Styling) {
      case 'naked-green':
        return 'Button--naked--green';
      case 'naked-blue':
        return 'Button--naked--blue';
      case 'naked':
        return 'Button--naked';
      case 'outline':
        return 'Button--outline';
      case 'dark':
        return 'Button--dark';
      case 'white':
        return 'Button--white';
      case 'gray':
        return 'Button--gray';
      default:
        return 'Button';
    }
  };

  return (
    <button
      className={`${getClasses()} ${
        size ? `Button--${size}` : ''
      } ${className}`}
      {...rest}
    >
      {children}
    </button>
  );
}
